import { useAuth } from "@workos-inc/authkit-react";
import { ConvexProviderWithAuth, type ConvexReactClient } from "convex/react";
import { type PropsWithChildren, useCallback, useMemo } from "react";
import { handleConvexError } from "@/lib/errors";

function useConvexAuth() {
	const { isLoading, user, getAccessToken } = useAuth();

	const fetchAccessToken = useCallback(async () => {
		try {
			return await getAccessToken();
		} catch (err) {
			if (user) {
				handleConvexError(err, "Session expired. Please sign in again.");
			}
			return null;
		}
	}, [getAccessToken, user]);

	return useMemo(
		() => ({ isLoading, isAuthenticated: !!user, fetchAccessToken }),
		[isLoading, user, fetchAccessToken],
	);
}

export function ConvexAuthProvider({
	children,
	client,
}: Readonly<
	PropsWithChildren<{
		client: ConvexReactClient;
	}>
>) {
	return (
		<ConvexProviderWithAuth client={client} useAuth={useConvexAuth}>
			{children}
		</ConvexProviderWithAuth>
	);
}
